import request from '@/utils/request'

let Warning_inventoryApi = {

  /*预警库存列表*/
  list(data) {
    return request._post('/shop/plus.warning_inventory.Index/index', data);
},
/*添加预警库存*/
add(data) {
    return request._post('/shop/plus.warning_inventory.Index/add', data);
},
/*修改预警库存*/
edit(data) {
    return request._post('/shop/plus.warning_inventory.Index/edit', data);
},
/*删除预警库存*/
del(data) {
    return request._post('/shop/plus.warning_inventory.Index/del', data);
},
/*预警库存详情*/
detail(data) {
  return request._post('/shop/plus.warning_inventory.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.warning_inventory.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.warning_inventory.Setting/getSetting', data, errorback);
    },
    editPart(data) {
        return request._post('/shop/plus.warning_inventory.Index/editPart', data);
    },
 
}
export default Warning_inventoryApi;



// WEBPACK FOOTER //
// ./src/api/warning_inventory.js